import {Pipe, PipeTransform} from "@angular/core";
import {TranslateService} from "@ngx-translate/core";
import {Observable} from "rxjs";
import {map} from "rxjs/operators";

@Pipe({
    name: 'yearDisplay',
    standalone: false
})
export class YearDisplayPipe implements PipeTransform {
	constructor(private translateService: TranslateService) {}

	transform(year: number): Observable<string> {
		return this.translateService.get([
			'common.year',
			'common.1st',
			'common.2nd',
			'common.3rd'
		]).pipe(
			map(translations => {
				const prefix = this.getPrefix(year, translations);
				return `${prefix} ${translations['common.year']}`;
			})
		);
	}

	private getPrefix(year: number, translations: any): string {
		switch (year) {
			case 1:
				return translations['common.1st'];
			case 2:
				return translations['common.2nd'];
			case 3:
				return translations['common.3rd'];
			default:
				return '';
		}
	}
}
